/**
 * Cambiar estado al loader
 * @param {Object} commit Commit
 * @param {Boolean} value Estado true/false
 */
export const isVisible = ({ commit }, value) => {
    setTimeout(() => {
        commit('IS_VISIBLE', value);
    }, 200);
};
